import {
   Box,
   Button,
   DataList,
   Flex,
   Heading,
   Skeleton,
   Switch,
   Text,
   TextArea,
   TextField,
} from '@radix-ui/themes';
import { AdminSideBar } from 'admin/elements/side-bar';
import APNavBar from 'Components/adminpanel/Elements/APNavBar';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { FormField } from 'shared/components';
import { IconWest } from 'shared/icons';
import { toast } from 'sonner';
import { SimpleResumeEditStore } from './SimpleResumeEdit.store';

function SimpleResumeEditView() {
   const [store] = useState(() => new SimpleResumeEditStore());
   const location = useLocation();
   const navigate = useNavigate();
   const p = useParams();
   const id = p.id;

   useEffect(() => {
      store.loadResume({ id: id! });
   }, [id]);

   return (
      <>
         <APNavBar />
         <Box pt="80px" className="simple-resume-manager">
            <Flex width="270px" minWidth="270px">
               <AdminSideBar />
            </Flex>

            <Flex p="6" direction="column" gap="4" width="100%">
               <Heading weight="medium">Edit Simple Resume:</Heading>
               <Skeleton width="600px" height="650px" loading={store.loadingResume}>
                  <form
                     onSubmit={(e) => {
                        e.preventDefault();
                        store.save(
                           { id: id! },
                           {
                              onSuccess: () => {
                                 toast.success('Save success');
                                 navigate({
                                    pathname: '/admin/simple-resumes',
                                    search: location.search,
                                 });
                              },
                              onError: (message) => {
                                 toast.error(message);
                              },
                           }
                        );
                     }}
                  >
                     <Box maxWidth="600px">
                        <Flex direction="column" gap="4">
                           <FormField label="Position">
                              <TextField.Root
                                 size="3"
                                 color="indigo"
                                 placeholder="Position"
                                 style={{ height: '44px' }}
                                 value={store.position}
                                 onChange={(e) => {
                                    store.setPosition(e.target.value);
                                 }}
                              />
                           </FormField>

                           <FormField label="Info">
                              <TextArea
                                 size="3"
                                 color="indigo"
                                 placeholder="Info"
                                 style={{ height: '44px' }}
                                 value={store.info}
                                 onChange={(e) => {
                                    store.setInfo(e.target.value);
                                 }}
                              />
                           </FormField>

                           <FormField label="Status">
                              <Switch
                                 size="3"
                                 color="green"
                                 checked={store.status}
                                 onCheckedChange={(checked) => {
                                    store.setStatus(checked);
                                 }}
                              ></Switch>
                           </FormField>
                        </Flex>

                        <Flex direction="column" mt="7">
                           <Heading as="h4" size="3" weight="medium" mb="3">
                              User information:
                           </Heading>
                           <DataList.Root size="3">
                              <DataList.Item>
                                 <DataList.Label minWidth="88px">Name:</DataList.Label>
                                 <DataList.Value>{store.user?.first_name}</DataList.Value>
                              </DataList.Item>

                              <DataList.Item>
                                 <DataList.Label minWidth="88px">Last Name:</DataList.Label>
                                 <DataList.Value>{store.user?.last_name}</DataList.Value>
                              </DataList.Item>

                              <DataList.Item align="center">
                                 <DataList.Label minWidth="88px">City:</DataList.Label>
                                 <DataList.Value>
                                    <Text> {store.simpleResume?.city?.city_name || ''}</Text>
                                 </DataList.Value>
                              </DataList.Item>

                              <DataList.Item>
                                 <DataList.Label minWidth="88px">Category:</DataList.Label>
                                 <DataList.Value>{store.selectedCategoryName}</DataList.Value>
                              </DataList.Item>

                              <DataList.Item>
                                 <DataList.Label minWidth="88px">Subcategory:</DataList.Label>
                                 <DataList.Value>{store.selectedSubcategoryName}</DataList.Value>
                              </DataList.Item>

                              <DataList.Item>
                                 <DataList.Label minWidth="88px">Email:</DataList.Label>
                                 <DataList.Value>
                                    <Flex align="center" gap="2">
                                       {store.user?.email_address}
                                    </Flex>
                                 </DataList.Value>
                              </DataList.Item>

                              <DataList.Item>
                                 <DataList.Label minWidth="88px">Phone:</DataList.Label>
                                 <DataList.Value>{store.user?.contact}</DataList.Value>
                              </DataList.Item>
                           </DataList.Root>
                        </Flex>
                     </Box>

                     <Flex mt="6" justify="between" maxWidth="600px">
                        <Button
                           size="4"
                           type="button"
                           color="indigo"
                           highContrast
                           variant="outline"
                           asChild
                        >
                           <Link
                              to={{
                                 pathname: '/admin/simple-resumes',
                                 search: location.search,
                              }}
                           >
                              <IconWest />
                              Back
                           </Link>
                        </Button>

                        <Button size="4" type="submit" loading={store.saveProcessing}>
                           Save
                        </Button>
                     </Flex>
                  </form>
               </Skeleton>
            </Flex>
         </Box>
      </>
   );
}

export const SimpleResumeEdit = observer(SimpleResumeEditView);
